var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TabLanguages',{attrs:{"tabLanguages":_vm.getLanguages,"activeLanguage":_vm.getTabLanguage.lang,"tabErrors":_vm.tabErrors},on:{"tabLanguageChanged":_vm.onTabLanguageChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }